import { AddOn } from '../../types/rateplan'

export const defaultAddOns: AddOn[] = [
  {
    code: 'AddBed',
    name: 'AddBed',
    applyMultiplier: false,
    // AddBed is always charged per night and per extra bed; the backend enforces it.
    perPerson: true,
    perRoomNight: true,
    type: 'AddBed',
    nameTranslatedList: [
      {
        label: 'Iran, Islamic Republic of',
        nativeLabel: 'فارسی',
        value: 'تخت اضافه'
      }
    ]
  },
  {
    code: 'Cot',
    name: 'Cot',
    applyMultiplier: false,
    perPerson: false,
    perRoomNight: false,
    type: 'Cot',
    nameTranslatedList: [
      {
        label: 'Iran, Islamic Republic of',
        nativeLabel: 'فارسی',
        value: 'تخت نوزاد'
      }
    ]
  },
  {
    code: 'Breakfast',
    name: 'Breakfast',
    applyMultiplier: false,
    perPerson: false,
    perRoomNight: false,
    type: 'Breakfast',
    nameTranslatedList: [
      {
        label: 'Iran, Islamic Republic of',
        nativeLabel: 'فارسی',
        value: 'صبحانه'
      }
    ]
  }
] as AddOn[]
